import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es7.string.pad-start";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _typeof from "/root/workspace/__flow_work/__flow_builds/3ed4544c-3c2a-4c7a-9f23-032dcb22c824/workspace/streffy-middle-office_rVCL/node_modules/@babel/runtime-corejs2/helpers/esm/typeof.js";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/3ed4544c-3c2a-4c7a-9f23-032dcb22c824/workspace/streffy-middle-office_rVCL/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es6.number.constructor";
import _regeneratorRuntime from "@babel/runtime-corejs2/regenerator";
import util from '@/libs/util';
import XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import axios from 'axios';
export default {
  props: {
    // 导出按钮类型 1 后端接口返回文件导出（默认）， 0 前端静态tableData数据导出
    type: {
      type: Number,
      required: false,
      default: 1
    },
    tableData: {
      type: Array,
      required: false,
      default: function _default() {
        return [];
      }
    },
    fileName: {
      type: String,
      required: false,
      default: '表格数据'
    },
    url: {
      type: String,
      required: false,
      default: ''
    },
    method: {
      type: String,
      required: false,
      default: 'post'
    },
    params: {
      type: [Object, String],
      required: false,
      default: null
    }
  },
  data: function data() {
    return {
      // 父级传入表格数据
      // tableData: []
      // tableTextData: [
      //     { name: '张三', age: 25, gender: '男' },
      //     { name: '李四', age: 30, gender: '女' }
      //     // ...
      // ]
    };
  },
  methods: {
    handleDownload: function () {
      var _handleDownload = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(this.type === 1)) {
                _context.next = 5;
                break;
              }
              _context.next = 3;
              return this.downloadFile();
            case 3:
              _context.next = 6;
              break;
            case 5:
              this.exportToExcel();
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function handleDownload() {
        return _handleDownload.apply(this, arguments);
      }
      return handleDownload;
    }(),
    // 后端接口返回文件导出（默认）
    downloadFile: function () {
      var _downloadFile = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var token, treeToken, portArgument, finalParams, parentComponent, response, url, link;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              token = util.cookies.get('token'); // 三方登录
              treeToken = window.localStorage.getItem('treeToken');
              if (treeToken) {
                token = treeToken;
              }
              // 发送POST或GET请求，获取文件流
              portArgument = {
                url: this.url,
                // 替换为你的文件下载接口
                method: this.method,
                // 或者 'get'，根据你的需求选择
                responseType: 'blob',
                // 表明服务器响应的数据类型
                headers: {
                  'Authorization': 'Bearer ' + token,
                  'Content-Type': 'application/json' // 🔧 显式设置Content-Type
                }
              }; // 请求，需要传递的数据
              // 🔧 动态获取最新参数：如果params是函数，则调用获取最新值
              finalParams = this.params;
              if (typeof this.params === 'function') {
                finalParams = this.params();
                console.log('🔄 通过函数动态获取参数:', finalParams);
              } else if (this.params && _typeof(this.params) === 'object' && this.params.constructor === Object) {
                // 如果是普通对象，检查是否需要从父组件重新获取
                parentComponent = this.$parent;
                if (parentComponent && typeof parentComponent.getExportParams === 'function') {
                  finalParams = parentComponent.getExportParams();
                  console.log('🔄 从父组件重新获取导出参数:', finalParams);
                } else if (parentComponent && parentComponent.dynamicExportParams) {
                  finalParams = parentComponent.dynamicExportParams;
                  console.log('🔄 使用父组件dynamicExportParams:', finalParams);
                }
              }
              console.log('🚀🚀🚀 导出组件最终使用的params:', finalParams);
              console.log('参数类型:', _typeof(finalParams));
              console.log('参数字段数量:', Object.keys(finalParams || {}).length);
              if (this.method === 'POST' || this.method === 'post') {
                portArgument.data = this.params;
                console.log('🚀 POST请求数据:', portArgument.data);
              } else if (this.method === 'GET' || this.method === 'get') {
                portArgument.params = this.params;
                console.log('🚀 GET请求参数:', portArgument.params);
              }
              _context2.next = 13;
              return axios(portArgument);
            case 13:
              response = _context2.sent;
              // 创建一个Blob对象，用于处理二进制数据
              url = window.URL.createObjectURL(new Blob([response.data], {
                type: 'application/vnd.ms-excel'
              })); // return false
              // 创建一个a标签用于下载
              link = document.createElement('a');
              link.href = url;
              link.setAttribute('download', "".concat(this.fileName, ".xlsx")); // 设置下载文件的名称，.ext是文件扩展名
              link.style.display = 'none'; // 隐藏a标签

              // 将a标签添加到DOM中
              document.body.appendChild(link);

              // 触发点击事件开始下载
              link.click();

              // 清理
              window.URL.revokeObjectURL(url);
              document.body.removeChild(link);
              _context2.next = 28;
              break;
            case 25:
              _context2.prev = 25;
              _context2.t0 = _context2["catch"](0);
              console.error('下载文件时出错:', _context2.t0);
            case 28:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[0, 25]]);
      }));
      function downloadFile() {
        return _downloadFile.apply(this, arguments);
      }
      return downloadFile;
    }(),
    // 前端静态tableData数据导出Excel
    exportToExcel: function exportToExcel() {
      // 创建新的工作簿（创建一个默认的 Excel 文件描述对象）
      var wb = XLSX.utils.book_new();

      // 创建新的工作表（将 js 数据的数组转换为工作表）
      var ws = XLSX.utils.json_to_sheet(this.tableData);
      // const ws = XLSX.utils.aoa_to_sheet(this.tableData);

      // 将工作表添加到工作簿
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

      // 导出工作簿为blob对象
      var wbOut = XLSX.write(wb, {
        bookType: 'xlsx',
        type: 'array'
      });

      // 使用file-saver保存文件
      try {
        var dateTime = this.formatDate(new Date());
        saveAs(new Blob([wbOut], {
          type: 'application/octet-stream'
        }), "".concat(this.fileName || dateTime, ".xlsx"));
      } catch (e) {
        if (typeof console !== 'undefined') console.log(e, wbOut);
      }
    },
    formatDate: function formatDate(date) {
      var year = date.getFullYear();
      var month = (1 + date.getMonth()).toString().padStart(2, '0');
      var day = date.getDate().toString().padStart(2, '0');
      var hours = date.getHours().toString().padStart(2, '0');
      var minutes = date.getMinutes().toString().padStart(2, '0');
      var seconds = date.getSeconds().toString().padStart(2, '0');
      return "".concat(year, "-").concat(month, "-").concat(day, " ").concat(hours, ":").concat(minutes, ":").concat(seconds);
    }
  }
};